import * as Utils from "@/utils";
namespace Constants {
  export const LOGGER_DEV = window.localStorage.getItem("LOGGER_DEV") === "1";

  /** 是否为开发环境 */
  export const IS_DEV = import.meta.env.MODE === "dev";

  /** 是否为开发/测试环境 */
  export const IS_DEBUG = import.meta.env.MODE !== "production";

  /** 是否使用debug模式；使用时会打开vconsole */
  export const IS_USEDEBUG = Utils.getDebugFlag() === "1";
}

export default Constants;
